export default __webpack_public_path__ + "static/logo-vault-staking-footer-188a3a6dbce6e36501b29ab11f795d43.svg";